export function Logo() {
  return (
    <span className="flex items-center gap-2.5">
      <img
        src="/logo8bit-mascot.png"
        alt=""
        width={392}
        height={448}
        className="px-pixelated h-10 w-auto"
      />
      <span className="px-font text-ink text-sm">SF Ruby CFP</span>
    </span>
  );
}
